"use client"
import { InfoIcon } from "@/templates/Admin/variants/default/utils/icons/index"
import { useState } from "react"
// import { useRef } from "react"
import { Edit, ArrowLeft } from "lucide-react"
import { Button } from "@/templates/Admin/components/Button/Button"
import { Input } from "@/templates/Admin/components/Input/Input"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/templates/Admin/components/Table/Table"
import { Avatar, AvatarFallback, AvatarImage } from "@/templates/Admin/components/Avatar/Avatar"
import { type User } from "@/types/user"
// import { useToast } from "@/templates/Admin/components/Toast/ToastProvider"
// import cmcServices from "@/templates/Admin/utils/services/cmcServices"

interface AvatarData {
  file: File | null;
  preview: string;
  name: string;
  size: number;
  isUploading: boolean;
  url: string | null;
}
interface UserDetailViewProps {
  user: User
  onBack: () => void
  onDisconnect: (userId: number, sessionId: number) => void
  onUpdateUser: (userId: number, updatedUser: Partial<User>) => void
}

export function UserDetailView({ user, onBack, onDisconnect, onUpdateUser }: UserDetailViewProps) {
  // const fileInputRef = useRef<HTMLInputElement>(null);
  // const { showSuccess, showError } = useToast();
  
  const [isEditing, setIsEditing] = useState(false)
  const [userAvatar, ] = useState<AvatarData | null>(
    user.avatar ? {
      file: null,
      preview: user.avatar || "",
      name: 'current-avatar',
      size: 0,
      isUploading: false,
      url: user.avatar || null,
    } : null
  );
  
  const [editForm, setEditForm] = useState({
    firstName: user.firstName || user.first_name || "",
    lastName: user.lastName || user.last_name || "",
    email: user.email,
    password: "",
  })

  // const handleAvatarUpload = async (file: File) => {
  //   if (file && file.type.startsWith('image/')) {
  //     try {
  //       // Create preview immediately for better UX
  //       const reader = new FileReader();
  //       reader.onload = (e) => {
  //         const avatarData = {
  //           file: file,
  //           preview: e.target?.result as string,
  //           name: file.name,
  //           size: file.size,
  //           isUploading: true,
  //           url: null, // Will be set after S3 upload
  //         };
  //         setUserAvatar(avatarData);
  //       };
  //       reader.readAsDataURL(file);

  //       // Upload to S3
  //       const formData = new FormData();
  //       formData.append('subfolder', `admin/users/avatars/`);
  //       formData.append('file', file);

  //       const uploadResult = await cmcServices.uploadToS3({ body: formData });

  //       // Check if upload failed
  //       if ('error' in uploadResult) {
  //         throw new Error(uploadResult.error);
  //       }

  //       const avatarUrl = (uploadResult as { data?: { file_url?: string } }).data?.file_url;
  //       if (!avatarUrl) {
  //         throw new Error('Không nhận được URL hình ảnh từ S3');
  //       }

  //       // Update avatar data with S3 URL
  //       const finalAvatarData = {
  //         file: file,
  //         preview: URL.createObjectURL(file),
  //         name: file.name,
  //         size: file.size,
  //         isUploading: false,
  //         url: avatarUrl,
  //       };

  //       setUserAvatar(finalAvatarData);
        
  //       // Update user data with new avatar
  //       const updatedData: Partial<User> = {
  //         avatar: avatarUrl,
  //       };
  //       onUpdateUser(user.id, updatedData);
        
  //       showSuccess('Cập nhật ảnh đại diện thành công!', 'Thành công');
  //     } catch (error: unknown) {
  //       console.error('Error uploading avatar:', error);
  //       showError((error as Error).message || 'Có lỗi xảy ra khi upload ảnh', 'Lỗi');

  //       // Reset uploading state on error
  //       setUserAvatar((prev: AvatarData | null) => (prev ? { ...prev, isUploading: false } : null));
  //     }
  //   }
  // };

  // const handleRemoveAvatar = () => {
  //   setUserAvatar(null);
  //   // Update user data to remove avatar
  //   const updatedData: Partial<User> = {
  //     avatar: null,
  //   };
  //   onUpdateUser(user.id, updatedData);
  //   showSuccess('Đã xóa ảnh đại diện', 'Thành công');
  // };

  // const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = event.target.files?.[0];
  //   if (file) {
  //     handleAvatarUpload(file);
  //   }
  // };

  // const triggerFileInput = () => {
  //   fileInputRef.current?.click();
  // };

  const handleEditToggle = () => {
    if (isEditing) {
      // Reset form when canceling
      setEditForm({
        firstName: user.firstName || user.first_name || "",
        lastName: user.lastName || user.last_name || "",
        email: user.email,
        password: "",
      })
    }
    setIsEditing(!isEditing)
  }

  const handleSave = () => {
    // Validate form
    if (!editForm.firstName.trim() || !editForm.lastName.trim() || !editForm.email.trim()) {
      alert("Vui lòng điền đầy đủ thông tin bắt buộc")
      return
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(editForm.email)) {
      alert("Vui lòng nhập email hợp lệ")
      return
    }

    // Update user data
    const updatedData: Partial<User> = {
      firstName: editForm.firstName,
      lastName: editForm.lastName,
      name: `${editForm.firstName} ${editForm.lastName}`,
      email: editForm.email,
    }

    onUpdateUser(user.id, updatedData)
    setIsEditing(false)
  }

  const handleInputChange = (field: string, value: string) => {
    setEditForm((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  return (
  <div className="max-h-[60vh] overflow-auto rounded-lg border bg-card text-card-foreground shadow-sm flex-1 max-w-4xl mx-auto p-6 transition-all duration-300">
    {/* Back Button */}
    <Button
      variant="ghost"
      onClick={onBack}
      className="mb-6 pl-0 text-blue-600 hover:text-blue-700 hover:bg-transparent"
    >
      <ArrowLeft className="cursor-pointer h-4 w-4 mr-2" />
      Quay lại
    </Button>

      {/* User Avatar and Welcome */}
      <div className="flex flex-col items-center mb-8">
        <div className="relative mb-4">
          <Avatar className="h-24 w-24">
            {userAvatar ? (
              <AvatarImage 
                src={userAvatar.preview || userAvatar.url || ""} 
                alt="" 
                className="object-cover"
              />
            ) : (
              <AvatarFallback className="text-2xl">
                {(user.name || `${user.first_name || ''} ${user.last_name || ''}`.trim() || user.username || 'U')
                  .split(" ")
                  .map((n) => n[0])
                  .join("")}
              </AvatarFallback>
            )}
          </Avatar>
          
          {/* Removed avatar editing functionality - only show avatar */}
        </div>
        <h2 className="text-xl font-semibold">Xin Chào, {user.name || `${user.first_name || ''} ${user.last_name || ''}`.trim() || user.username}!</h2>
      </div>

      {/* Edit/Save Controls */}
      <div className="flex justify-end mb-6 gap-2">
        {isEditing ? (
          <>
            <Button variant="outline" onClick={handleEditToggle}>
              Hủy
            </Button>
            <Button onClick={handleSave} className="bg-green-600 hover:bg-green-700">
              Lưu thay đổi
            </Button>
          </>
        ) : (
          <Button onClick={handleEditToggle} className="bg-blue-600 hover:bg-blue-700">
            <Edit className="h-4 w-4 mr-2" />
            Chỉnh sửa thông tin
          </Button>
        )}
      </div>

      {/* Two Column Layout */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Left Column - General Information */}
        <div>
          <h3 className="text-lg font-semibold mb-4 text-gray-800">THÔNG TIN CHUNG</h3>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Họ {isEditing && <span className="text-red-500">*</span>}
              </label>
              <Input
                value={isEditing ? editForm.firstName : (user.firstName || user.first_name || "")}
                onChange={(e) => handleInputChange("firstName", e.target.value)}
                readOnly={!isEditing}
                className={isEditing ? "border-blue-300 focus:border-blue-500" : "bg-gray-100"}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Tên {isEditing && <span className="text-red-500">*</span>}
              </label>
              <Input
                value={isEditing ? editForm.lastName : (user.lastName || user.last_name || "")}
                onChange={(e) => handleInputChange("lastName", e.target.value)}
                readOnly={!isEditing}
                className={isEditing ? "border-blue-300 focus:border-blue-500" : "bg-gray-100"}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">User ID</label>
              <Input value={user.userId || user.username || ""} readOnly className="bg-gray-100" />
              {isEditing && <p className="text-xs text-gray-500 mt-1">User ID không thể thay đổi</p>}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email {isEditing && <span className="text-red-500">*</span>}
              </label>
              <Input
                type="email"
                value={isEditing ? editForm.email : user.email}
                onChange={(e) => handleInputChange("email", e.target.value)}
                readOnly={!isEditing}
                className={isEditing ? "border-blue-300 focus:border-blue-500" : "bg-gray-100"}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Mật khẩu {isEditing && "(Để trống nếu không muốn thay đổi)"}
              </label>
              <Input
                type="password"
                value={isEditing ? editForm.password : ""}
                onChange={(e) => handleInputChange("password", e.target.value)}
                placeholder={isEditing ? "Nhập mật khẩu mới" : "••••••••"}
                readOnly={!isEditing}
                className={isEditing ? "border-blue-300 focus:border-blue-500" : "bg-gray-100"}
              />
              {isEditing && <p className="text-xs text-gray-500 mt-1">Mật khẩu phải có ít nhất 8 ký tự</p>}
            </div>
          </div>

          {/* Edit Mode Notice */}
          {isEditing && (
            <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <InfoIcon />
                </div>
                <div className="ml-3">
                  <h3 className="text-sm font-medium text-blue-800">Chế độ chỉnh sửa</h3>
                  <div className="mt-2 text-sm text-blue-700">
                    <p>Bạn đang ở chế độ chỉnh sửa. Vui lòng kiểm tra kỹ thông tin trước khi lưu.</p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Right Column - Login History & Devices */}
        <div>
          <h3 className="text-lg font-semibold mb-4 text-gray-800">LỊCH SỬ ĐĂNG NHẬP & THIẾT BỊ</h3>
          <div className="border rounded-lg overflow-hidden">
            <Table>
              <TableHeader>
                <TableRow className="bg-gray-50">
                  <TableHead>Lần đăng nhập</TableHead>
                  <TableHead>Thiết bị</TableHead>
                  <TableHead className="w-32">Tác vụ</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {(user.loginHistory || []).map((session) => (
                  <TableRow key={session.id} className="hover:bg-gray-50">
                    <TableCell>
                      <div className="font-medium">{session.time}</div>
                      <div className="text-sm text-gray-500">ngày {session.date}</div>
                    </TableCell>
                    <TableCell>{session.device}</TableCell>
                    <TableCell>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => onDisconnect(user.id, session.id)}
                        className="text-red-600 hover:text-red-700 hover:bg-red-50 border-red-200"
                        disabled={isEditing}
                      >
                        Ngắt kết nối
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
          {isEditing && (
            <p className="text-xs text-gray-500 mt-2">
              Các tác vụ quản lý phiên đăng nhập bị vô hiệu hóa trong chế độ chỉnh sửa
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
